// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner--spinner--bce9ef","darkStroke":"Spinner--darkStroke--10045e"};